export const getOffers = ({ offerReducer: { offers = [] } = {} }) => offers;
export const getOfferFilters = ({ offerReducer: { filter = {} } = {} }) =>
  filter;
export const getOffersCount = ({ offerReducer: { count = 0 } = {} }) => count;
export const getPartners = ({ offerReducer: { partners = [] } = {} }) => partners;
export const getPartnerFilter = ({ offerReducer: { partner_filter = {} } = {} }) =>
partner_filter;
